import React from 'react';
import './benefits.scss'

import BENEFITS_IMAGE from 'assets/business-education-assets/benefits_image.png';
import POINTING_LADY_2 from 'assets/business-education-assets/pointing_lady_2.png';
// import DOT_ELEMENT from 'assets/elements/dots_element.svg';

import GROWTH_ICON from 'assets/icons/growth_icon.png';
import OWNER_ICON from 'assets/icons/owner_icon.png';
import INDEPENDENCE_ICON from 'assets/icons/independence_icon.png';
import LOAN_ICON from 'assets/icons/loan_icon.png';
import {HeadingElement, Button} from "../../../../components";
import {useNavigate} from "react-router-dom";


const Benefits = () => {
    const navigate = useNavigate()
    return (
        <div className={'benefits'} id={"Business_Benefits"}>
            <div className="benefits_wrapper max">
                <div className="benefits_wrapper_left">
                    <div className="benefits_wrapper_left_content">
                        <img id='beach' src={BENEFITS_IMAGE} alt=""/>
                        <img id="pointing_lady" src={POINTING_LADY_2} alt=""/>
                    </div>
                </div>
                <div className="benefits_wrapper_right">
                    <div className="benefits_wrapper_right_content">
                        <HeadingElement/>
                        <h1>Benefits of starting a Business</h1>
                        <p>
                            Starting a business often comes with many complexities; however, 
                            a successful Startup attracts financial, lifestyle independence, 
                            personal satisfaction, and growth rewards through hard work and determination.
                        </p>
                        <span id={'benefits'}>Benefits:</span>

                        <div className="benefits_wrapper_right_content_benefits">
                            <div className="benefits_wrapper_right_content_benefits_benefit">
                                <img src={GROWTH_ICON} alt=""/>
                                <span>Contributing to comm- unity Growth</span>
                            </div>

                            <div className="benefits_wrapper_right_content_benefits_benefit">
                                <img src={INDEPENDENCE_ICON} alt=""/>
                                <span>Independence and Flexibility</span>
                            </div>

                            <div className="benefits_wrapper_right_content_benefits_benefit">
                                <img src={OWNER_ICON} alt=""/>
                                <span>Establishing ownership of the business</span>
                            </div>

                            <div className="benefits_wrapper_right_content_benefits_benefit">
                                <img src={LOAN_ICON} alt=""/>
                                <span>Accessing business loans and grants</span>
                            </div>
                        </div>
                        <Button text={'Learn More'} type={'primary'} onclick={()=>navigate('/about')}/>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Benefits;
